import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Loader2, Save, FileDown } from 'lucide-react';
import authedFetch from '../../lib/authedFetch';
import { TextField } from './FieldKit';

const API = process.env.REACT_APP_BACKEND_URL;

export default function StepOperatingNumbers({ orgId, step, state, onSave, saving, shareToken }) {
  const [draft, setDraft] = useState(state.answers || {});
  useEffect(() => { setDraft(state.answers || {}); }, [state]);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  const downloadTemplate = async () => {
    const url = `${API}/api/onboarding/template/operating_numbers${orgId ? `?org_id=${orgId}` : ''}`;
    const r = shareToken ? await fetch(url) : await authedFetch(url);
    const csv = await r.text();
    const blob = new Blob([csv], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'seertech_operating_numbers_template.csv';
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 space-y-4" data-testid="onboarding-step-operating-numbers">
      <div className="flex items-center justify-end">
        <Button variant="outline" size="sm" onClick={downloadTemplate} data-testid="onb-operating-template-btn">
          <FileDown className="h-3.5 w-3.5 mr-2" /> CSV template
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {step.fields.map((f) => (
          <TextField key={f.key} field={f} value={draft[f.key]} onChange={set} testIdPrefix="onb-operating" />
        ))}
      </div>
      <div className="flex justify-end pt-2">
        <Button onClick={() => onSave(draft)} disabled={saving} data-testid="onb-operating-save">
          {saving ? <Loader2 className="h-3.5 w-3.5 mr-2 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-2" />}
          Save & continue
        </Button>
      </div>
    </div>
  );
}
